export default __webpack_public_path__ + "static/media/envimac.05533db0.jpg";